const displayTypes: Record<string, string> = {
  showLyrics_showChords_showSection: 'lyrics_chords_diagrams_sections',
  showLyrics_showChords: 'lyrics_chords_diagrams',
  showChords_showSection: 'chords_diagrams_sections',
  showLyrics_showSection: 'lyrics_sections',
  showChords: 'chords_diagrams',
  showSection: 'sections',
  showLyrics: 'lyrics'
}

export const getDisplayType = ({
  showLyrics,
  showChords,
  showSections
}: {
  showLyrics: boolean
  showChords: boolean
  showSections: boolean
}): string => {
  const keys = []
  if (showLyrics) keys.push('showLyrics')
  if (showChords) keys.push('showChords')
  if (showSections) keys.push('showSection')
  return displayTypes[keys.join('_')] ?? 'stems'
}

export const getTotalTimeSpent = (startTime: string): number => {
  const startDate = new Date(startTime).getTime()
  const now = Date.now()
  return Math.floor((now - startDate) / 1000)
}
